import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            blackLevel: anyImageOpResult.or(z.number()),
            whiteLevel: anyImageOpResult.or(z.number()),
            gamma: z.number().optional().default(1),
        }),
    },
}
